export default {
  category: 'book',
  name: 'The Way to Love',
  author: 'Anthony de Mello',
  date: '11/7/20',
  path: '/notes/the-way-to-love',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-way-to-love-anthony-de-mello.jpg',
  tags: ['Self-help', 'Spirituality'],
  time: 12,
  rating: 9.4,
  review: '',
  link: 'https://www.amazon.com/Way-Love-Meditations-Anthony-Classics/dp/038524939X',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
